import React, { Component } from "react";
import {LogEvent} from '@learningblocks/shared-components/lib/EventLogger';

import "./EndSimulation.scss";

import warningIcon from "./img/warning-modal-icon.svg";
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux';
import {showModal} from 'actions';

class EndSimulation extends Component {

  endSimulation = () => {
    this.props.showModal(false);
  };

  closePlatformDialog = () => {
    window.parent.postMessage({
      method: 'event',
      data: {type: 'requestClose'}
    }, '*');
    return false;
  }

  render() {
    return (
      <div className="modal-section endSimulationModal">
        <img alt="Warning icon." src={warningIcon} className="warningIcon" />
        <h3 className="heading">
          {this.props.t("End simulation")}
        </h3>
        <p className="endDescription">{this.props.t("Are you sure you want to end this simulation?")}</p>
        <div className="modal-footer">
          <div onClick={this.closePlatformDialog}>
            <LogEvent
              logEventProps={{
                event_type: "sim_summary_finish_btn clicked",
                event_schema: "track"
              }}
              actionProps={{ onClick: { action: 'click' } }}
              elementType="button"
            >
              <button className='endSimulation' onClick={()=>this.endSimulation}>
                {this.props.t("End simulation")}
              </button>
            </LogEvent>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    level: state.notebook.level,
  }
}

export default connect(mapStateToProps, {
    showModal,
})(withTranslation()(EndSimulation));
